import script from "./leftPie3.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie3.vue?vue&type=script&setup=true&lang=js"

import "./leftPie3.vue?vue&type=style&index=0&id=35cedbb2&scoped=true&lang=css"
script.__scopeId = "data-v-35cedbb2"

export default script